import { createListenerMiddleware, isAnyOf } from '@reduxjs/toolkit';
import { AUTO_ROTATE_INTERVAL } from 'common/components/constant';
import {
  CurrentFeed,
  updateMediaSetting,
  updateCurrentAutoRotateFeed,
  updateGlobalMediaSettings,
} from 'common/slice/mediaSettingSlice';

const mediaSettingListener = createListenerMiddleware();

const state = {
  currentAutoIndex: 0,
  intervalId: null,
};

const rotateFeeds = (availableSettings) => {
  state.currentAutoIndex = (state.currentAutoIndex + 1) % availableSettings.length;
};

mediaSettingListener.startListening({
  matcher: isAnyOf(updateMediaSetting, updateGlobalMediaSettings),
  effect: async (action, listenerApi: any) => {
    const mediaSettingsState = listenerApi.getState().mediaSettings;
    if (updateMediaSetting.match(action) || updateGlobalMediaSettings.match(action)) {
      const { currentFeed } = action.payload;
      if (currentFeed === 'auto-rotate') {
        if (!state.intervalId) {
          state.intervalId = setInterval(() => {
            rotateFeeds(mediaSettingsState.availableSettings);
            const nextActiveFeed = mediaSettingsState.availableSettings[state.currentAutoIndex];
            listenerApi.dispatch(
              updateCurrentAutoRotateFeed({
                currentAutoRotateFeed: nextActiveFeed as CurrentFeed,
              }),
            );
          }, AUTO_ROTATE_INTERVAL);
        }
      } else {
        const hasAutoRotateSettings =
          listenerApi
            .getState()
            .mediaSettings.mediaSettings.some((setting) => setting.currentFeed === 'auto-rotate') ||
          listenerApi.getState().mediaSettings.mediaSettings.currentFeed === 'auto-rotate';
        if (!hasAutoRotateSettings) {
          if (state.intervalId) {
            clearInterval(state.intervalId);
            state.intervalId = null;
          }
        }
      }
    }
  },
});

export default mediaSettingListener;
